import { LanguageSwitcher, Wrapper } from "src/components";
import { ContentContainer, PageHeader } from "src/components/Layouts/AppShell";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const SettingLanguagesScreenContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBackButton = () => {
    navigate("/settings");
  };

  return (
    <Wrapper isAuthorizedWrapper idSelector={"wrapperContainer"}>
      <ContentContainer size="narrow">
        <PageHeader
          title={t("settings.Languages.title")}
          onBack={handleBackButton}
        />
        <LanguageSwitcher isDropDownType={false} />
      </ContentContainer>
    </Wrapper>
  );
};
